import { capitalize } from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const QuestionScale = ({ labelLeft, labelRight, answer }) => {
  return (
    <div className="question-scale">
      <div className="question-scale-numbers">
        {[1, 2, 3, 4, 5].map((number, index) => (
          <div
            className={
              answer === number
                ? "question-scale-number-selected"
                : "question-scale-number"
            }
            key={`scale-number-${index}`}
          >
            {number}
          </div>
        ))}
      </div>
      <div className="question-scale-labels">
        <span className="question-scale-label">{String(labelLeft)}</span>
        <span className="question-scale-label" style={{ textAlign: "right" }}>
          {String(labelRight)}
        </span>
      </div>
    </div>
  );
};

export const CreateQuestionScaleBody = ({ data, setData }) => {
  const { t } = useTranslation("athlete-portal");
  const [labels, setLabels] = useState({
    labelLeft: data.body.labelLeft || "",
    labelRight: data.body.labelRight || "",
  });

  const handleChange = (e, field) => {
    const { value } = e.target;

    setLabels((previousState) => ({
      ...previousState,
      [field]: capitalize(value),
    }));

    setData((previousState) => ({
      ...previousState,
      body: {
        ...previousState.body,
        [field]: capitalize(value),
      },
    }));
  };

  return (
    <div className="answer-scale-body">
      <div className="question-scale">
        <div className="question-scale-numbers">
          <div className="question-scale-number">1</div>
          <div className="question-scale-number">2</div>
          <div className="question-scale-number">3</div>
          <div className="question-scale-number">4</div>
          <div className="question-scale-number">5</div>
        </div>
        <div className="question-scale-labels">
          <input
            type="text"
            name="question-short"
            placeholder={t("questionScale.label1Placeholder")}
            className="answer-input-scale"
            maxLength={40}
            onChange={(e) => {
              handleChange(e, "labelLeft");
            }}
            value={labels["labelLeft"]}
          />
          <input
            type="text"
            name="question-short"
            placeholder={t("questionScale.label5Placeholder")}
            className="answer-input-scale"
            maxLength={40}
            onChange={(e) => {
              handleChange(e, "labelRight");
            }}
            value={labels["labelRight"]}
          />
        </div>
      </div>
      <div className="no-buttons"></div>
    </div>
  );
};

export default QuestionScale;
